import { PropsWithChildren } from 'react';

/**
 * Wrapper for modal content.
 * Content is the scrollable area.
 */
export const LuiModalAsyncContent = ({ children }: PropsWithChildren<unknown>) => (
  <div className={'LuiModalAsync-content'}>{children}</div>
);
